import React, { useState } from "react";
import "./Style.css";

import api, { apiUrl } from '../../../../services/api';
import axios from 'axios';

import { Link, useNavigate } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { css } from "@emotion/react";
import 'react-toastify/dist/ReactToastify.min.css';

import BeatLoader from "react-spinners/BeatLoader";
import { AiOutlineConsoleSql } from "react-icons/ai";
import { BsPaypal } from "react-icons/bs";


export default function () {

  const [CodigoBarra, setCodigoBarra] = useState('')
  const [loader, setLoader] = useState(false)

  const [info, setInfo] = useState(false)
  const [response, setResponse] = useState(false)
  const [due, setDue] = useState(false)
  const [pay, setPay] = useState(false)

  const navigate = useNavigate();

  const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

  async function PayTicket() {
    setLoader(true)
    setPay(false)

    let dueList = due.split('/');

    const body = {
      taxNumber: localStorage.getItem('taxNumber'),
      barCode: response.DigitableLine,
      dueDate: dueList[2]+'/'+dueList[1]+'/'+dueList[0],
      value: response.Value
    }

    console.log(response);
    console.log(body);

    const obj = {
      username: localStorage.getItem('taxNumber'),
      password: localStorage.getItem('identifier'),
      mac: localStorage.getItem('deviceId'),
      login: localStorage.getItem('login')
    }    

    await api.post('/login/token', obj)
      .then(async function (result) {
        localStorage.setItem('token', result.data.token);

        const api2 = await axios.create({
            headers: {
                'Authorization': result.data.token,
                'device': localStorage.getItem('deviceId')
            },
            baseURL: apiUrl
        })

        
        var pay = await api2.post('/payment/store', body)
          .then(response => {
            toast.success('Boleto pago com sucesso!')
          })
          .catch(err => {
              setLoader(false)
              setPay(true)
              toast.error(err.response.data.message)
              return;
          })
          
        console.log('pay', pay);
        setLoader(false)
        setInfo(true)
        setPay(true)
      })
  }




  async function GetTicket() {
    if (CodigoBarra == '') {
      toast.error('Preencha todos os campos!')
      return;
    }

    setLoader(true)

    const obj = {
      username: localStorage.getItem('taxNumber'),
      password: localStorage.getItem('identifier'),
      mac: localStorage.getItem('deviceId'),
      login: localStorage.getItem('login')
    }

    await api.post('/login/token', obj)
      .then(async function (result) {
        localStorage.setItem('token', result.data.token);

        const api2 = await axios.create({
            headers: {
                'Authorization': result.data.token,
                'device': localStorage.getItem('deviceId')
            },
            baseURL: apiUrl
        })

        var split = CodigoBarra.split('')[0];

        const body = {
          'taxNumber': localStorage.getItem('taxNumber'),
          'barCode': CodigoBarra
      }

        if (split == '8') { // Boleto de concessionária
          var getInfos = await api2.post('/payment/getinfosbar', body)
            .catch(err => {
                setLoader(false)
                toast.error(err.response.data.message)
                return;
            })
          
          console.log('getInfos', res);
          var res = JSON.parse(getInfos.data.data.Infos);
          setResponse(res)
          let vencList = response.DueDate.toString().split('T')[0].split('-');
          console.log(vencList);
          
          setDue(vencList[2]+'/'+vencList[1]+'/'+vencList[0]);
          setPay(true);
          setLoader(false)
          setInfo(true)
          
        } else { // boleto de banco (CIP)
          var getInfos = await api2.post('/payment/getinfos', body)
            .catch(err => {
                setLoader(false)
                toast.error(err.response.data.message)
                return;
            })

          var res = JSON.parse(getInfos.data.data.Infos);
          console.log('getInfos', res);
          setResponse(res)
          console.log(response)
          console.log(res['DueDate'])
          let vencList = res['DueDate'].split('T')[0].split('-');
          console.log(vencList);
          setDue(vencList[2]+'/'+vencList[1]+'/'+vencList[0]);
          setPay(true);
          setLoader(false)
          setInfo(true)
        }
      })
  }

  return (
    <div>
      <div className="pagar-boleto">
        <div className="container">
          <div className="boleto row">
            <div className="col-xl-6">
              <p>Boleto</p>
            </div>

            {/*<div className="gera-boleto col-xl-2">
              <Link to={"/pagina-novo-boleto"}>
                <button>Novo Boleto</button>
              </Link>
            </div>


            <div className="col-xl-2">
              <Link to={"/pagina-boleto"}>
                <button>Boletos</button>
              </Link>
            </div>

            <div className="col-xl-2">
              <Link to={"/pagina-pagar-boleto"}>
                <button>Pagar</button>
              </Link>
            </div>
            */}
          </div>

          <div className="transferencia">
            <div className="row">
              <div className="scroll col-xl-6">
                <div>
                  <h1>Pagar Boleto</h1>
                </div>

                <div>
                  <h2>Digite o número do código de barras para realizar o pagamento</h2>
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Digite o Codigo de barras"
                    value={CodigoBarra}
                    onChange={e => { setCodigoBarra(e.target.value) }}
                  />
                </div>
                <div className="botao-confirmar">
                  <button onClick={e => GetTicket()}>Localizar</button>
                </div>

              </div>

              <div className="col-xl-6">
                <div className="resumo-transferencia">
                  <div>
                    <h1>Resumo do Boleto</h1>
                  </div>

                  <div style={info ? { 'display': 'block' } : { 'display': 'none' }}>
                      <div>
                          <p>Beneficiário</p>
                          <h4>{response.BeneficiaryName}</h4>
                      </div>

                      <div>
                          <p>Valor</p>
                          <h4>{response.UpdatedValue}</h4>
                      </div>

                      <div>
                          <p>Vencimento</p>
                          <h4>{due}</h4>
                      </div>

                      <div>
                          <p>Quando será pago</p>
                          <h4>Hoje</h4>
                      </div>
                  </div>

                  <div style={loader ? { 'display': 'block', 'margin': 'auto', 'marginTop': '20px' } : { 'display': 'none' }}>
                      <BeatLoader color={"var(--secondary-color)"} loading={loader} css={override} size={20} />
                  </div>
                </div>

                <div className="botao-confirmar">
                    <button
                        style={pay ? { 'display': 'block' } : { 'display': 'none' }}
                        onClick={() => PayTicket()}>Confirmar pagamento
                    </button>

                    <button
                        style={loader ? { 'display': 'block' } : { 'display': 'none' }}
                        onClick={() => toast.info('Requisição em processamento!')} >
                        <BeatLoader color={"#fff"} loading={loader} css={override} size={10} />
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
